import { categoriasPet } from '../../helpers/funcoesAuxiliares';
import { verificarExcecaoPetPorLocalidade } from '../validadoresComunsPorPlano/excecoes';
import { validatorAte64Anos, retornaLabelDoValorParentesco, validatorParentescoEmDuplicidade, validatorMaior79Anos, validatorMaiorIgual65Anos } from './funcoesAuxiliaresZT';

export class CorrenteEdicaoZT {
    constructor(
        dependentes,
        parentesco,
        categorias,
        valoresForm,
        valoresAnterioresForm
    ) {
        //CPF: ""
        // Categoria: ""
        // DepSexo: ""
        // Email: ""
        // Idade: ""
        // Nascimento: ""
        // Nome: ""
        // Parentesco: ""
        // Telefone: ""
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.valoresAnterioresForm = valoresAnterioresForm;
        this.maximoDependentesPet = 1;
    }

    infringeParentescoComAdicionalAte64() {
        if (validatorAte64Anos(this.valoresForm)) {
            this.arrayMsgsErro.push('Para dependentes de até 64 anos, o adicional permitido é o ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    infringeParentescoComAdicionalMaiorIgual65() {
        if (validatorMaiorIgual65Anos(this.valoresForm)) {
            this.arrayMsgsErro.push('Para dependentes acima de 65 anos, o adicional permitido é o ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    parentescoComAdicionalMaior79() {
        if (validatorMaior79Anos(this.valoresForm)) {
            this.arrayMsgsErro.push('Para dependentes acima de 79 anos, o adicional permitido é o ZELO MAIOR 79 ANOS.');
        }

        return this;
    }

    parentescoEmDuplicidade() {
        if (validatorParentescoEmDuplicidade(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push(`${retornaLabelDoValorParentesco(this.parentesco)}`);
        }

        return this;
    }

    excecaoPetPorLocalidade() {
        if (verificarExcecaoPetPorLocalidade(this.valoresForm.Categoria.trim(), this.valoresForm.Parentesco.trim())) {
            this.arrayMsgsErro = [];
        }

        return this;
    }

    permitirDependentePetSomenteComAdicionalPet() {
        if (this.valoresForm.Parentesco.trim === 'PET' && !categoriasPet.includes(this.valoresForm.Categoria.trim())) {
            this.arrayMsgsErro.push('Somente é permitido dependente PET que tenha como adicional referente ao PET');
        }

        return this;
    }

    limitarQuantidadePet() {
        const numeroDependentesPet = this.dependentes.filter(dependente => dependente['GrauParentesco.Grau'].trim() === 'PET').length;

        if (this.valoresForm.Parentesco.trim() === 'PET' && this.valoresAnterioresForm.Parentesco !== 'PET') {
            if (numeroDependentesPet >= this.maximoDependentesPet) {
                this.arrayMsgsErro.push(`Só é permitido um dependente do tipo ${this.valoresForm.Parentesco}.`);
            }
        }

        return this;
    }
}
